<template>
  <div id="market-list-component">
    <div class="market-wrap h-100">
      <div class="module-head">
        <div class="search-box d-flex justify-space-between align-center">
          <div class="font-15" style="color:#ffffff;">{{ $t('labels.trade.market') }}</div>
          <div class="hidden-input">
            <input type="password" autocomplete="off" />
          </div>
        </div>
      </div>
      <div v-if="loading" class="module-body d-flex justify-center align-center">
        <div class="exchange-loading">
          <div class="loading-inner">
            <v-progress-circular class="mr-1" color="#ffffff" indeterminate size="25" width="3"></v-progress-circular>
            <span class="loading-text color-fff">{{ $t('labels.loading') }}...</span>
          </div>
        </div>
      </div>
      <div v-else class="module-body">
        <v-tabs class="tabs-wrap" v-model="activeTab">
          <v-tab class="tabs-head" v-for="coin in marketListGroup" :key="coin" :label="coin" :name="coin">
            {{ coin }}
          </v-tab>
        </v-tabs>

        <v-tabs-items class="tabs-item-wrap" v-model="activeTab">
          <v-tab-item class="tabs-item" v-for="(coin, index) in marketListGroup" :key="index">
            <ul class="trade-list-caption">
              <li class="caption-item">{{ $t('labels.finance.coin') }}</li>
              <li class="caption-item">{{ $t('labels.trade.latestPrice') }}</li>
              <li class="caption-item">{{ $t('labels.trade.change') }}</li>
            </ul>
            <div class="trade-area-scroll" :class="{ 'has-scroll': hasScroll }">
              <ol class="trade-list">
                <li
                  class="trade-item"
                  v-for="market in marketList[coin]"
                  v-if="1 == market.status"
                  :key="market.symbol"
                  :data-symbol="market.symbol"
                  :data-area="coin"
                  :class="{ active: market.symbol === Getter_Current_Market.symbol }"
                  @click="marketItemClick(market)"
                >
                  <div class="item-text" :data-symbol="market.symbol" :data-area="coin">
                    <div class="coin-name" :data-symbol="market.symbol" :data-area="coin">{{ convertPair(market) }}</div>
                  </div>
                  <div class="item-text latest-price" :data-symbol="market.symbol" :data-area="coin">
                    {{ '0' == market.close || 0 == market.close ? '0.00' : !market.close ? '-' : convertDecimal(market.close, market.priceDec) }}
                  </div>
                  <div
                    class="item-text"
                    :data-symbol="market.symbol"
                    :data-area="coin"
                    :class="{
                      'color-buy': Number(market.change) > 0,
                      'color-sell': Number(market.change) < 0,
                      change: Number(market.change) == 0
                    }"
                  >
                    {{ !market.change ? '-' : market.change > 0 ? '+' + `${parseFloat(market.change).toFixed(2)}%` : `${parseFloat(market.change).toFixed(2)}%` }}
                  </div>
                </li>
                <li class="no-data" v-if="marketList[coin] && marketList[coin].length === 0">
                  {{ $t('common.noRecords') }}
                </li>
              </ol>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>
  </div>
</template>

<script>
import index from './market.js';
export default index;
</script>

<style lang="stylus" scoped>
@import 'market.styl'
</style>
